import { Controller, useFormContext } from 'react-hook-form';
import { DashboardPageFormBody, DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { Input, Textarea } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import type { TailoredSupplyCreateFormValue } from '../../createFormSchema';

export function TailoredSupplyGeneralFields() {
  const { control } = useFormContext<TailoredSupplyCreateFormValue>();

  return (
    <DashboardPageFormBody>
      <Controller
        control={control}
        name="name"
        render={({ field, fieldState }) => (
          <DashboardPageFormField
            label={dashboardT('tailoredSupply.nameLabel')}
            htmlFor="tailored-supply-name"
            required
            error={fieldState.error?.message}
          >
            <Input
              {...field}
              id="tailored-supply-name"
              maxLength={255}
              required
              aria-invalid={Boolean(fieldState.error)}
            />
          </DashboardPageFormField>
        )}
      />
      <Controller
        control={control}
        name="description"
        render={({ field, fieldState }) => (
          <DashboardPageFormField
            label={dashboardT('tailoredSupply.description')}
            htmlFor="tailored-supply-description"
            error={fieldState.error?.message}
          >
            <Textarea
              {...field}
              id="tailored-supply-description"
              rows={5}
              aria-invalid={Boolean(fieldState.error)}
            />
          </DashboardPageFormField>
        )}
      />
    </DashboardPageFormBody>
  );
}
